import './OtherItem.css'

const OtherItem = ({name,price}) => {
    return <div className="otheritem_container">
    <div className="name">{name}</div>
    <div className="price">{price}</div>
    
</div>;
}
 
export default OtherItem;